<app-olci-prompts-inner [layoutState]="layoutState$ | async" [bundle]="bundle()" [screensize]="screensize$ | async"></app-olci-prompts-inner>
